"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var MetaBase_1 = require("./MetaBase");
var ClassNameMetaBase = (function (_super) {
    __extends(ClassNameMetaBase, _super);
    function ClassNameMetaBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ClassNameMetaBase.prototype.renderProps = function (childProps) {
        return __assign({}, childProps, { className: this.renderClassName(childProps) });
    };
    ClassNameMetaBase.prototype.renderNativeDOMProps = function (childProps) {
        return {};
    };
    ClassNameMetaBase.prototype.renderClassName = function (childProps) {
        return classNames.apply(void 0, [this.renderBaseClassName(childProps)].concat(this.renderClassValues(childProps), [this.props.className,
            childProps.className]));
    };
    ClassNameMetaBase.prototype.renderBaseClassName = function (childProps) {
        return null;
    };
    ClassNameMetaBase.prototype.renderClassValues = function (childProps) {
        return [];
    };
    return ClassNameMetaBase;
}(MetaBase_1.default));
exports.default = ClassNameMetaBase;
//# sourceMappingURL=ClassNameMetaBase.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@react-mdc/base/lib/ClassNameMetaBase.js
// module id = ./node_modules/@react-mdc/base/lib/ClassNameMetaBase.js
// module chunks = 1 2 3